<template src="./RiskProbabilityChart.html"></template>

<script>
// Rendered as plain DOM, not the app's Chart.vue/Plotly wrapper — plotly.js
// is pinned at 1.58.5 here (via vue-plotly@1.1.0), which has neither
// marker.pattern (2.x, needed for the small-sample hatch) nor
// marker.cornerradius (2.28+, needed for the bar radius), and Chart.vue's
// scatter layout computes its own y-range with a 10% buffer — directly
// against this chart's one non-negotiable, a Y axis fixed 0-100 that never
// fits the data. See the plan doc for the full reasoning.
import { rampAccent } from "@/modules/DataAnalysis/Risk/riskFormat";

export default {
  name: "RiskProbabilityChart",
  props: {
    bars: { type: Array, default: () => [] },
    presentation: { type: Object, default: null },
    windowLabel: { type: String, default: "" },
    narrow: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  computed: {
    title() {
      return (this.presentation && this.presentation.chartTitle) || "Probability by Week (%)";
    },
    legendLabel() {
      const label = (this.presentation && this.presentation.legendLabel) || "Probability";
      return this.windowLabel ? `${label} (${this.windowLabel})` : label;
    },
    yTicks() {
      return [100, 75, 50, 25, 0];
    },
    // The legend swatch has to follow the indicator's ramp, so it cannot live in
    // the stylesheet the way it used to (a hardcoded #4372ab). Derived from
    // presentation.id rather than taken as a new prop — the bars carry
    // pre-computed colors, but an empty `bars` still needs a legend.
    accent() {
      return rampAccent(this.presentation && this.presentation.id);
    },
  },
  methods: {
    barStyle(bar) {
      return {
        height: `${bar.heightPct}%`,
        background: bar.hatch || bar.fill,
        color: bar.inkOnFill,
      };
    },
    valueLabel(bar) {
      if (bar.pctDisplay == null) return "—";
      return `${bar.prefix}${bar.pctDisplay}%`;
    },
  },
};
</script>

<style lang="scss" src="./RiskProbabilityChart.scss"></style>
